

































import { Vue, Component, Prop, Watch, Model } from 'vue-property-decorator';

import InputWrapper from '@/componentsV2/molecules/Inputs/InputWrapper.vue';
import CheckboxInline from '@/componentsV2/molecules/CheckboxInline/CheckboxInline.vue';
import InputBase from '@/componentsV2/molecules/Inputs/InputBase.vue';

type BulkCheckboxesOption = {
  id: string;
  label?: string;
  checked?: boolean;
  title?: string;
  imageSrc?: string;
};

@Component<BulkCheckboxes>({
  components: {
    CheckboxInline,
    InputWrapper
  }
})
export default class BulkCheckboxes extends InputBase {
  @Model('input', { type: Array }) value!: Array<BulkCheckboxesOption>;

  @Prop({ default: 'All' }) allLabel?: string;
  @Prop({ default: () => [] }) options!: Array<BulkCheckboxesOption>;
  @Prop({ default: false }) enableEllipsis?: boolean;
  @Prop({ default: false }) disabledBackgroundAllOption?: boolean;
  @Prop() componentToRender?: any;

  allIsMarcked = false;
  hasAtLeastOneOptionSelected = false;
  formData: Record<string, boolean> = this.options.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.id]: !!curr.checked
    }),
    {}
  );

  @Watch('formData', { deep: true, immediate: true })
  onFormDataChange(formDataState: Record<string, boolean>) {
    const selectedOptions = this.options
      .map(option => ({
        ...option,
        checked: formDataState[option.id]
      }))
      .filter(option => option.checked);

    this.allIsMarcked = !!selectedOptions.length;
    this.hasAtLeastOneOptionSelected =
      selectedOptions.length > 0 &&
      selectedOptions.length < this.options.length;

    this.$emit('input', selectedOptions);
  }

  handleAll(checked: boolean) {
    this.formData = this.options.reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: checked
      }),
      {}
    );
  }
}
